import { defineMessages } from 'react-intl'

export default defineMessages({
  description: {
    id: 'containers.CustomerOrderUpsertPage.components.VoiceTalent.description',
    defaultMessage: 'Please note the unavailability of the voice talents in the dropdown',
  }
})
